import axios from 'axios'

export default {
  getBrands () {
    return axios.get(process.env.VUE_APP_BACKEND_BASE_URL + '/brands').then((response) => {
      return response
    })
  },
  getBrandsForCategory (categoryId) {
    return axios.get(process.env.VUE_APP_BACKEND_BASE_URL + '/brands/category/' + categoryId).then((response) => {
      return response
    })
  },
  createBrand (brand) {
    return axios.post(process.env.VUE_APP_BACKEND_BASE_URL + '/brands', brand).then((response) => {
      return response
    })
  },
  editBrand (brand) {
    return axios.put(process.env.VUE_APP_BACKEND_BASE_URL + '/brands', brand).then((response) => {
      return response
    })
  },
  deleteBrand (brandId) {
    return axios.delete(process.env.VUE_APP_BACKEND_BASE_URL + '/brands/' + brandId).then((response) => {
      return response
    })
  }
}
